import { render } from "./Ordering.vue?vue&type=template&id=cda73ae2&scoped=true"
import script from "./Ordering.vue?vue&type=script&lang=js"
export * from "./Ordering.vue?vue&type=script&lang=js"

import "./Ordering.vue?vue&type=style&index=0&id=cda73ae2&lang=scss&scoped=true"
import "./Ordering.vue?vue&type=style&index=1&id=cda73ae2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda73ae2"]])

export default __exports__